/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_CssInputs */

const en_image_inspector_css = /** @type {(inputs: Image_Inspector_CssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSS`)
};

const ar_image_inspector_css = /** @type {(inputs: Image_Inspector_CssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSS`)
};

const bn_image_inspector_css = /** @type {(inputs: Image_Inspector_CssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSS`)
};

const de_image_inspector_css = /** @type {(inputs: Image_Inspector_CssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSS`)
};

const es_image_inspector_css = /** @type {(inputs: Image_Inspector_CssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSS`)
};

const fr_image_inspector_css = /** @type {(inputs: Image_Inspector_CssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSS`)
};

const pt_image_inspector_css = /** @type {(inputs: Image_Inspector_CssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSS`)
};

const zh_image_inspector_css = /** @type {(inputs: Image_Inspector_CssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSS`)
};

const tr_image_inspector_css = /** @type {(inputs: Image_Inspector_CssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSS`)
};

const ru_image_inspector_css = /** @type {(inputs: Image_Inspector_CssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSS`)
};

const pl_image_inspector_css = /** @type {(inputs: Image_Inspector_CssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSS`)
};

/**
* | output |
* | --- |
* | "CSS" |
*
* @param {Image_Inspector_CssInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_css = /** @type {((inputs?: Image_Inspector_CssInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_CssInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_css(inputs)
	if (locale === "bn") return bn_image_inspector_css(inputs)
	if (locale === "de") return de_image_inspector_css(inputs)
	if (locale === "es") return es_image_inspector_css(inputs)
	if (locale === "fr") return fr_image_inspector_css(inputs)
	if (locale === "pt") return pt_image_inspector_css(inputs)
	if (locale === "zh") return zh_image_inspector_css(inputs)
	if (locale === "tr") return tr_image_inspector_css(inputs)
	if (locale === "ru") return ru_image_inspector_css(inputs)
	if (locale === "pl") return pl_image_inspector_css(inputs)
	return en_image_inspector_css(inputs)
});